import { postRoute } from "../client"
export const shopEquipRoute = postRoute<{ success: boolean; equipped?: boolean; error?: string }>("/api/shop/equip")
